import React from 'react';

import InteractiveErrorToaster from 'application/components/InteractiveErrorToaster';
import { TEXTS } from 'application/pages/texts';
import CommunicationUtils from 'application/utils/CommunicationUtils';

import { Country } from '@shared/api/graphql/generated';
import { toast } from '@shared/ui';

export const showCopyStreamError = (country: Country) => {
  const id = toast.error(
    <InteractiveErrorToaster
      onSubmit={() => {
        CommunicationUtils.connectWithManager(country);
        toast.dismiss(id);
      }}
      onClose={() => {
        toast.dismiss(id);
      }}
      title={TEXTS.SET_STREAM_ERROR_TITLE}
      submitButtonTitle={TEXTS.SET_STREAM_ERROR_ACTION}
      closeButtonTitle={TEXTS.SET_STREAM_ERROR_CLOSE}
      elementId="set_stream_error"
    />,
    { closeOnClick: false, duration: 5000 }
  );
};
